// src/stores/notifications.ts
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { notificationService, type AppNotification } from '@/services/notificationService'

export const useNotificationsStore = defineStore('notifications', () => {
  const notifications = ref<AppNotification[]>([])
  const isLoading = ref(false)
  const hasFetchedOnce = ref(false)

  const unreadCount = computed(() => notifications.value.filter(n => !n.read).length)

  async function fetchNotifications() {
    isLoading.value = true
    try {
      const res = await notificationService.getNotifications()
      if (res.success && Array.isArray(res.data)) {
        notifications.value = res.data
      }
      hasFetchedOnce.value = true
    } catch {
      // Non-critical — the header works fine without this list loading.
    } finally {
      isLoading.value = false
    }
  }

  async function markRead(id: string) {
    const item = notifications.value.find(n => n.id === id)
    if (item) item.read = true
    try {
      await notificationService.markRead(id)
    } catch {}
  }

  async function markAllRead() {
    notifications.value.forEach(n => { n.read = true })
    try {
      await notificationService.markAllRead()
    } catch {}
  }

  function reset() {
    notifications.value = []
    hasFetchedOnce.value = false
  }

  return {
    notifications,
    isLoading,
    hasFetchedOnce,
    unreadCount,
    fetchNotifications,
    markRead,
    markAllRead,
    reset,
  }
})
